<template>
    <div class="planData">
        <Page :renderSearchList="renderList" :searchData="searchData" :tableData="tableData" :total="total" :current="current" :pageSize="pageSize" @changeCurrrent="handleChangeCurrrent" @changePageSize="handleChangePageSize" @changeSearchDat="handleChangeSearchData" @search="handleSearch" showDownload downloadText="导出" @download="handleDownload">
            <div class="table-content" ref="tableContent" :style="`height: ${tableHeight}px`">
                <Table style="width: 100%" show-summary :summary-method="getSummaries" :data="tableData" size="medium" stripe v-if="tableData.length && !isLoading" :default-sort="defaultSort" :height="tableHeight" @sort-change="handleSortChange">
                    <el-table-column prop="createDate" label="日期" width="100" fixed></el-table-column>
                    <!-- planId adCreateTime -->
                    <el-table-column prop="goodsId" label="计划ID/创建时间" width="180" fixed>
                        <template slot-scope="scope">
                            <div>{{scope.row.planId | filtersCell}}</div>
                            <div>{{scope.row.adCreateTime | filtersCell}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cost" label="消耗" width="100" sortable="custom" fixed></el-table-column>
                    <el-table-column prop="customerOrderValidTotalSalePrice" label="GMV" width="104" sortable="custom" fixed>
                        <template slot="header">
                            <Popover placement="top-start" width="200" trigger="hover" content="GMV：原总销售额，包含退款订单金额在内">
                                <span slot="reference">GMV</span>
                            </Popover>
                        </template>
                    </el-table-column>
                    <el-table-column prop="customerTotalSaleRoi" label="roi" width="100" fixed>
                        <template slot="header">
                            <Popover placement="top-start" width="200" trigger="hover" content="roi：GMV/消耗">
                                <span slot="reference">roi</span>
                            </Popover>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="userInfo.showOrderValidNum === 1" prop="customerOrderValidEstimateCosPrice" label="净销售额" width="104" sortable="custom"></el-table-column>
                    <el-table-column v-if="userInfo.showOrderValidNum === 1" prop="customerRoi" label="净roi" width="100"></el-table-column>
                    <!-- adCpaBid -->
                    <el-table-column prop="adCpaBid" label="出价" width="90"></el-table-column>
                    <el-table-column prop="convert_cost" label="转化成本" width="95" sortable="custom"></el-table-column>
                    <!-- goodsPrice -->
                    <!-- <el-table-column prop="customerGoodsPrice" label="商品单价" width="72"></el-table-column> -->
                    <!-- orderNum -->
                    <el-table-column prop="customerOrderNum" label="总订单数" width="100" sortable="custom"></el-table-column>
                    <!-- orderValidNum -->
                    <el-table-column prop="customerOrderValidNum" label="有效订单数" width="104" sortable="custom"></el-table-column>
                    <!-- orderReturnNum -->
                    <!-- <el-table-column prop="customerOrderReturnNum" label="退款订单数" width="104" sortable="custom"></el-table-column> -->
                    <!-- orderReturnTotalPrice -->
                    <!-- <el-table-column prop="customerOrderReturnTotalPrice" label="退单金额" width="72"></el-table-column> -->
                    <el-table-column prop="convert" label="转化数" width="80"></el-table-column>
                    <el-table-column prop="customerOrderReturnNum" label="退款订单数" width="104" sortable="custom"></el-table-column>
                    <el-table-column prop="customerOrderReturnTotalPrice" label="退款金额" width="100" sortable="custom"></el-table-column>
                    <el-table-column prop="click" label="点击数" width="90"></el-table-column>
                    <el-table-column prop="avg_click_cost" label="点击成本" width="90"></el-table-column>
                    <el-table-column prop="show" label="展示数" width="90"></el-table-column>
                    <el-table-column prop="avg_show_cost" label="千次展示成本" width="94"></el-table-column>
                    <!--  -->
                    <el-table-column prop="planName" label="计划名称" width="180"></el-table-column>
                    <el-table-column prop="advertiseName" label="账户名称(ID)" width="180">
                        <template slot-scope="scope">
                            <div>{{scope.row.advertiseName | filtersCell}}</div>
                            <div>{{scope.row.advertiseId | filtersCell}}</div>
                        </template>
                    </el-table-column>
                    <!-- <template slot-scope="scope">
                        <div>{{scope.row.goodsName | filtersCell}}</div>
                        <div>{{scope.row.goodsId | filtersCell}}</div>
                    </template> -->
                    <!-- <el-table-column prop="goodsId" label="商品推广ID" width="130"></el-table-column> -->
                    <!-- <el-table-column prop="fetchUpdateAt" label="买量更新时间" width="166">
                        <template slot-scope="scope">
                            <div>{{scope.row.fetchUpdateAt | filtersDate }}</div>
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column prop="statisticUpdateAt" label="订单更新时间" width="166">
                        <template slot-scope="scope">
                            <div>{{scope.row.statisticUpdateAt | filtersDate }}</div>
                        </template>
                    </el-table-column> -->
                </Table>

                <div class="table-normal" v-if="!tableData.length && !isLoading">
                    <img src="@/assets/home/dataEffect/accountData/default_img_no_data.png" alt="">
                    <span>目前暂无数据</span>
                </div>

                <div v-if="isLoading">
                    <WfLoading></WfLoading>
                </div>
            </div>
        </Page>

        <div :class="`planData-mobile`">
            <PageMobile title="计划级数据" :renderSearchList="renderMobileList" :searchData="searchMobileData" :total="total" :current="current" :pageSize="pageSize" @changeCurrrent="handleChangeCurrrent" @search="handleSearch" @change="handleChangeSearchMobileData" :showDownload="false" @download="handleDownload">
                <div class="table-content" ref="tableContentMobile" :style="`height: ${tableHeight}px`">
                    <Table :data="tableData" show-summary :summary-method="getSummaries" size="small" :height="tableHeight" stripe v-if="tableData.length && !isLoading" :default-sort="defaultSort" @sort-change="handleSortChange">
                        <el-table-column prop="createDate" label="日期" width="90"></el-table-column>
                        <!-- planId adCreateTime -->
                        <el-table-column prop="goodsId" label="计划ID/创建时间" width="166">
                            <template slot-scope="scope">
                                <div>{{scope.row.planId | filtersCell}}</div>
                                <div>{{scope.row.adCreateTime | filtersCell}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="cost" label="消耗" width="88" sortable="custom"></el-table-column>
                        <el-table-column prop="customerOrderValidTotalSalePrice" label="GMV" width="92" sortable="custom"></el-table-column>
                        <el-table-column prop="customerTotalSaleRoi" label="roi" width="92"></el-table-column>
                        <el-table-column v-if="userInfo.showOrderValidNum === 1" prop="customerOrderValidEstimateCosPrice" label="净销售额" width="92" sortable="custom"></el-table-column>
                        <el-table-column v-if="userInfo.showOrderValidNum === 1" prop="customerRoi" label="净roi" width="92"></el-table-column>
                        <!-- adCpaBid -->
                        <el-table-column prop="adCpaBid" label="出价" width="88"></el-table-column>
                        <el-table-column prop="convert_cost" label="转化成本" width="92" sortable="custom"></el-table-column>
                        <!-- goodsPrice -->
                        <!-- <el-table-column prop="customerGoodsPrice" label="商品单价" width="72"></el-table-column> -->
                        <!-- orderNum -->
                        <el-table-column prop="customerOrderNum" label="总订单数" width="92" sortable="custom"></el-table-column>
                        <!-- orderValidNum -->
                        <el-table-column prop="customerOrderValidNum" label="有效订单数" width="104" sortable="custom"></el-table-column>
                        <!-- orderReturnNum -->
                        <!-- <el-table-column prop="customerOrderReturnNum" label="退款订单数" width="104" sortable="custom"></el-table-column> -->
                        <!-- orderReturnTotalPrice -->
                        <!-- <el-table-column prop="customerOrderReturnTotalPrice" label="退单金额" width="72"></el-table-column> -->
                        <el-table-column prop="convert" label="转化数" width="88"></el-table-column>
                        <el-table-column prop="customerOrderReturnNum" label="退款订单数" width="104" sortable="custom"></el-table-column>
                        <el-table-column prop="customerOrderReturnTotalPrice" label="退款金额" width="100" sortable="custom"></el-table-column>
                        <el-table-column prop="click" label="点击数" width="88"></el-table-column>
                        <el-table-column prop="avg_click_cost" label="点击成本" width="88"></el-table-column>
                        <el-table-column prop="show" label="展示数" width="88"></el-table-column>
                        <el-table-column prop="avg_show_cost" label="千次展示成本" width="94"></el-table-column>
                        <!--  -->
                        <el-table-column prop="planName" label="计划名称" width="72"></el-table-column>
                        <el-table-column prop="advertiseName" label="账户名称(ID)" width="170">
                            <template slot-scope="scope">
                                <div>{{scope.row.advertiseName | filtersCell}}</div>
                                <div>{{scope.row.advertiseId | filtersCell}}</div>
                            </template>
                        </el-table-column>
                        <!-- <template slot-scope="scope">
                        <div>{{scope.row.goodsName | filtersCell}}</div>
                        <div>{{scope.row.goodsId | filtersCell}}</div>
                    </template> -->
                        <el-table-column prop="goodsId" label="商品推广ID" width="130"></el-table-column>
                        <el-table-column prop="fetchUpdateAt" label="买量更新时间" width="166">
                            <template slot-scope="scope">
                                <div>{{scope.row.fetchUpdateAt | filtersDate }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="statisticUpdateAt" label="订单更新时间" width="166">
                            <template slot-scope="scope">
                                <div>{{scope.row.statisticUpdateAt | filtersDate }}</div>
                            </template>
                        </el-table-column>
                    </Table>

                    <div class="table-normal" v-if="!tableData.length && !isLoading">
                        <img src="@/assets/home/dataEffect/accountData/default_img_no_data.png" alt="">
                        <span>目前暂无数据</span>
                    </div>

                    <div v-if="isLoading">
                        <WfLoading></WfLoading>
                    </div>
                </div>
            </PageMobile>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Page from '@/components/page/page.vue'
import Icon from 'iview/src/components/icon';
import { Table, TableColumn, Loading, Popover } from 'element-ui';
import WfLoading from '@/components/loading/loading.vue'
import PageMobile from '@/components/pageMobile/pageMobile.vue'
Vue.use(Table)
Vue.use(TableColumn)
import moment from 'moment'
import { dateFormat, isEmpty, deepClone } from '@/utils/common.js'
import { renderList, renderMobileList } from './config'
import { sortDict, totalToColMap } from '@/pages/home/config.js'
import { getHideCustomerIdSearch } from '../accountData/config'
import fileDownload from 'js-file-download'

export default {
    components: {
        Page,
        Icon,
        Table,
        WfLoading,
        PageMobile,
        Popover
    },
    data() {
        return {
            self: this,
            renderList: deepClone(renderList),
            renderMobileList: deepClone(renderMobileList),
            tableData: [],
            searchData: {
                startCreateDate: dateFormat(new Date(), 'YYYY-MM-DD'),
                endCreateDate: dateFormat(new Date(), 'YYYY-MM-DD')
            },
            searchMobileData: {
                dates: [dateFormat(new Date(), 'YYYY-MM-DD'), dateFormat(new Date(), 'YYYY-MM-DD')]
            },
            userInfo: JSON.parse(localStorage.userInfo || '{}'),
            isLoading: true,
            tableTotalData: {},
            total: 0,
            pageSize: 15,
            current: 1,
            tableHeight: "",
            sortFieldName: '',
            sortDirection: ''
        }
    },
    filters: {
        filtersCell(value) {
            if (value) {
                return value
            } else {
                return '-'
            }
        },
        filtersDate(value) {
            if (value) {
                return moment(value).format('YYYY-MM-DD HH:mm:ss')
            } else {
                return '--'
            }
        }
    },
    computed: {
        defaultSort() {
            return {
                prop: this.sortFieldName,
                order: sortDict[this.sortDirection]
            }
        }
    },
    mounted() {
        if (this.$route.params && this.$route.params.advertiseId) {
            this.$set(this.searchData, 'advertiseId', this.$route.params.advertiseId)
        }
        if (window.innerWidth > 768) {
            this.tableHeight = this.$refs.tableContent ? this.$refs.tableContent.offsetHeight : ""
        } else {
            this.tableHeight = this.$refs.tableContentMobile ? (this.$refs.tableContentMobile.offsetHeight) : ""
        }
        // this.getTableTotalData()
        this.initData()
        if (!getHideCustomerIdSearch()) {
            this.$set(this.renderList[4], 'isHide', false)
            this.$set(this.renderMobileList[3], 'isHide', false)
            this.initPage()
        }
    },
    methods: {
        // 初始化数据
        initData() {
            this.isLoading = true
            Promise.all([this.getTableTotalData(), this.getTableData()]).then((result) => {
                if (!isEmpty(result[0].Data)) {
                    for (let i = 0; i < totalToColMap.length; i++) {
                        const totalToColMapItem = totalToColMap[i]
                        result[0].Data[totalToColMapItem.from] = result[0].Data[totalToColMapItem.to]
                    }
                    // result[0].Data.roi = result[0].Data.cost ? (result[0].Data.customerOrderValidEstimateCosPrice / result[0].Data.cost).toFixed(2) : 0
                }
                this.tableTotalData = result[0].Data || {}
                this.tableData = result[1].Data.data || []
                this.total = result[1].Data.total
                this.$nextTick(() => {
                    this.isLoading = false
                })
            }).catch(() => {
                this.isLoading = false
            })
        },

        // 初始化页面
        initPage() {
            Promise.all([this.getAllCustomer()]).then((result) => {
                const customerOptions = result[0].map((item) => {
                    return {
                        label: item.name,
                        value: item.customerId
                    }
                })
                this.$set(this.renderList[4], 'options', customerOptions)
                this.$set(this.renderMobileList[3], 'options', [{ label: '无', value: undefined }, ...customerOptions])
            })
        },

        // 处理点击下载事件
        handleDownload() {
            let loadingInstance = Loading.service({
                fullscreen: true,
                lock: true,
                text: '正在导出...',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            this.$axios({
                url: '/api/syn/rebateDataPlat/plan/listExport',
                data: {
                    ...this.searchData,
                    current: this.current,  
                    pageSize: this.pageSize,
                    showOrderValidNum: this.userInfo.showOrderValidNum || 2
                },
                method: 'GET',
                responseType: 'blob'
            }).then((res) => {
                loadingInstance.close()
                const { data } = res, fileName = decodeURI((res).headers['content-disposition']).substring(20)
                fileDownload(data, fileName)
            }).catch(() => {
                loadingInstance.close()
            })
        },

        // 获取所有客户
        getAllCustomer() {
            return new Promise((resolve, reject) => {
                this.$axios({
                    url: '/api/syn/rebateDataPlat/customer/all',
                    data: {
                    },
                    method: 'GET'
                }).then((res) => {
                    resolve(res.Data)
                })
            })
        },

        // 获取账户级数据
        getTableData() {
            const searchData = { ...this.searchData }
            searchData.customerId = searchData.customerId || '0'
            return new Promise((resove, reject) => {
                this.$axios({
                    url: '/api/syn/rebateDataPlat/plan/list',
                    data: {
                        ...searchData,
                        current: this.current,
                        pageSize: this.pageSize,
                        sortFieldName: this.sortFieldName,
                        sortDirection: this.sortDirection
                    },
                    method: 'GET'
                }).then((res) => {
                    if (Array.isArray(res.Data.data) && res.Data.data.length) {
                        res.Data.data.map((item) => {
                            item.roi = item.cost ? (item.customerOrderValidEstimateCosPrice / item.cost).toFixed(2) : 0
                        })
                    }
                    resove(res)
                })
            })
        },

        // 获取账户级数据汇总数据
        getTableTotalData() {
            const searchData = { ...this.searchData }
            searchData.customerId = searchData.customerId || '0'
            return new Promise((resove, reject) => {
                this.$axios({
                    url: '/api/syn/rebateDataPlat/plan/total',
                    data: {
                        ...searchData,
                        current: this.current,
                        pageSize: this.pageSize
                    },
                    method: 'GET'
                }).then((res) => {
                    resove(res)
                })
            })
        },

        // 处理排序改变时触发
        handleSortChange(event) {
            const { column, prop, order } = event
            this.sortDirection = sortDict[order]
            this.sortFieldName = prop
            this.getTableData().then((res) => {
                this.tableData = res.Data.data || []
                this.total = res.Data.total || 0
            })
        },

        // 处理合计逻辑
        getSummaries(param) {
            const { columns, data } = param, sums = [], tableTotalData = { ...this.tableTotalData }
            for (let i = 0; i < columns.length; i++) {
                const columnItem = columns[i]
                if (i === 0) {
                    sums.push('合计')
                } else {
                    if (isEmpty(tableTotalData[columnItem.property])) {

                        sums.push('--')
                    } else {
                        sums.push(tableTotalData[columnItem.property])
                    }
                }
            }
            return sums;
        },

        // 处理搜索事件
        handleSearch() {
            this.current = 1
            this.initData()
        },

        // 处理移动端搜索改变事件
        handleChangeSearchMobileData(data) {
            const currData = { ...data }
            const dates = currData.dates
            delete currData.dates
            this.searchData = {
                startCreateDate: dates[0],
                endCreateDate: dates[1],
                ...currData
            }
        },

        // 当前页改变时触发
        handleChangeCurrrent(current) {
            this.current = current
            this.initData()
        },

        // pageSize改变时触发
        handleChangePageSize(pageSize) {
            this.current = 1
            this.pageSize = pageSize
            this.initData()
        },

        // 处理搜索框改变时触发
        handleChangeSearchData(eventData) {
            const { data, item } = eventData, key = item.key
            if (key === "startCreateDate") {
                const renderItem = { ...this.renderList[1] }
                if (data[key]) {
                    renderItem.minDate = moment(data[key]).format('YYYY-MM-DD')
                    renderItem.maxDate = moment(data[key]).add(31, 'd').format('YYYY-MM-DD')
                    if (data.endCreateDate) {
                        const dateTime = new Date(data[key]).getTime(), endTime = new Date(data.endCreateDate).getTime()
                        if (dateTime > endTime || dateTime < endTime - 86400000 * 31) {
                            data.endCreateDate = null
                        }
                    }
                } else {
                    renderItem.minDate = ""
                    renderItem.maxDate = ""
                }
                this.$set(this.renderList, 1, renderItem)
            }
            if (key === "endCreateDate") {
                const renderItem = { ...this.renderList[0] }
                if (data[key]) {
                    renderItem.minDate = moment(data[key]).subtract(31, 'd').format('YYYY-MM-DD')
                    renderItem.maxDate = moment(data[key]).format('YYYY-MM-DD')
                    if (data.startCreateDate) {
                        const dateTime = new Date(data[key]).getTime(), startTime = new Date(data.startCreateDate).getTime()
                        if (dateTime < startTime || dateTime > startTime + 86400000 * 31) {
                            data.startCreateDate = null
                        }
                    }
                } else {
                    renderItem.minDate = ""
                    renderItem.maxDate = ""
                }
                this.$set(this.renderList, 0, renderItem)
            }
            this.searchData = data
        }
    }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px) {
    .planData {
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 20px;
        background-color: #fff;
        .planData-mobile {
            display: none;
        }
        .planData-content {
            flex: 1;
        }
        .planData-bottom {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
        }
    }
}
@media screen and (max-width: 768px) {
    .planData {
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 1.1rem 0 0;
        background-color: #f7f7f7;
        .wf-page {
            display: none;
        }
        .planData-content {
            flex: 1;
        }
        .planData-mobile {
            min-height: 100%;
            display: block;
            display: flex;
            flex-direction: column;
            padding: 0 0.3rem 0.3rem;
            .table-content {
                flex: 1;
                overflow-x: auto;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/dataEffect/planData/index.vue